module.exports = __webpack_public_path__ + "img/more-bt-wood.ba03e54f.png";